module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "app"
  }, [_c('scroll', {
    on: {
      "refresh": _vm.refresh
    }
  }, [_c('section', {
    staticClass: "agreemment-content",
    domProps: {
      "innerHTML": _vm._s(_vm.agreement)
    }
  })])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2750a11e","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/modules/login/Agreement.vue
// module id = 802
// module chunks = 0